<template>
  <b-card>
    <b-table
      :fields="fields"
      :items="notificationsData"
      class="table-borderless position-relative"
      responsive
    >
      <template #cell(portal)="data">
        <b-form-checkbox
          v-model="data.item.portal"
          @change="onUpdateNotificacion(data.item)"
        />
      </template>
      <template #cell(sms)="data">
        <b-form-checkbox
          v-model="data.item.sms"
          @change="onUpdateNotificacion(data.item)"
        />
      </template>
      <template #cell(whatsapp)="data">
        <b-form-checkbox
          v-model="data.item.whatsapp"
          @change="onUpdateNotificacion(data.item)"
        />
      </template>
      <template #cell(correo)="data">
        <b-form-checkbox
          v-model="data.item.correo"
          @change="onUpdateNotificacion(data.item)"
        />
      </template>
    </b-table>
  </b-card>
</template>

<script>
import {
  BCard,
  BTable,
  BFormCheckbox,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import accountService from '@/services/account.service'
import i18n from '@/libs/i18n'

export default {
  components: {
    BCard,
    BTable,
    BFormCheckbox,
  },
  props: {
    generalData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    /* Services */
    const {
      fetchNotificationsSettings,
      updateNotificationsSettings,
    } = accountService()
    /* Data */
    const usrData = ref(JSON.parse(JSON.stringify(props.generalData)))
    const notificationsData = ref([])
    const fields = [
      {
        label: i18n.t('PageAccount.notifications.labelNotification'),
        key: 'notificacionOrigen.nombre',
      },
      {
        label: i18n.t('PageAccount.notifications.portal'),
        key: 'portal',
      },
      {
        label: i18n.t('PageAccount.notifications.sms'),
        key: 'sms',
      },
      {
        label: i18n.t('PageAccount.notifications.whatsApp'),
        key: 'whatsapp',
      },
      {
        label: i18n.t('PageAccount.notifications.email'),
        key: 'correo',
      },
    ]

    const refetchNotifications = () => {
      fetchNotificationsSettings(data => {
        notificationsData.value = data
      }, usrData.value.userName)
    }

    refetchNotifications()
    /* Events */
    const onUpdateNotificacion = item => {
      updateNotificationsSettings(item, () => {
        refetchNotifications()
      })
    }

    return {
      // Data
      notificationsData,
      fields,
      // Events
      onUpdateNotificacion,
    }
  },
}
</script>
<style>
  .table-borderless > tbody > tr > td,
  .table-borderless > tbody > tr > th,
  .table-borderless > tfoot > tr > td,
  .table-borderless > tfoot > tr > th,
  .table-borderless > thead > tr > td,
  .table-borderless > thead > tr > th {
      border: none;
  }
</style>
